export default function RNDModePage() {
    return <div>Hello from Research and Development</div>;
  }